// extracted by mini-css-extract-plugin
module.exports = {"root":"FormRegistryList_root_200mf","filter":"FormRegistryList_filter_1xOeK","timeline":"FormRegistryList_timeline_3-85r","progress":"FormRegistryList_progress_3eLzf"};